// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Addroducttype_secondaryBtn__KnH\\+h {
  background: #F3EFFD;
  color: #4c2fb3;
  border: 1px solid #DCD3F9;
  font-weight: 600;
  font-size: 13px;
  padding: 8px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}
.Addroducttype_secondaryBtn__KnH\\+h:hover {
  background: #E7DEFB;
}

.Addroducttype_headerActions__EPVUe {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.Addroducttype_modalBox__2cftP {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(43, 22, 87, 0.24);
}

.Addroducttype_modalHeader__fp5NY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
}

.Addroducttype_modalTitle__Fs7sS {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
}

.Addroducttype_modalClose__CeXLW {
  color: #ffffff;
  cursor: pointer;
  display: flex;
}

.Addroducttype_downloadLink__aFYkw {
  display: inline-block;
  margin-left: 10px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
  cursor: pointer;
}

.Addroducttype_modalBody__txlIc {
  padding: 20px;
}

.Addroducttype_modalFileInput__cSGZN {
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed #C9BCF2;
  background: #FAF8FF;
  font-size: 13px;
  cursor: pointer;
}

.Addroducttype_modalFooter__9J6sr {
  display: flex;
  justify-content: flex-end;
  padding: 14px 20px 20px;
}

.Addroducttype_modalSubmitBtn__EJoMl {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 13.5px;
  padding: 9px 22px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.Addroducttype_modalSubmitBtn__EJoMl:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/producttype/Addroducttype.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,8CAA8C;EAC9C,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":[".secondaryBtn {\n  background: #F3EFFD;\n  color: #4c2fb3;\n  border: 1px solid #DCD3F9;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n.secondaryBtn:hover {\n  background: #E7DEFB;\n}\n\n.headerActions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 20px 50px rgba(43, 22, 87, 0.24);\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n}\n\n.downloadLink {\n  display: inline-block;\n  margin-left: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.9);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.modalBody {\n  padding: 20px;\n}\n\n.modalFileInput {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px dashed #C9BCF2;\n  background: #FAF8FF;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  padding: 14px 20px 20px;\n}\n\n.modalSubmitBtn {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  border: none;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 13.5px;\n  padding: 9px 22px;\n  border-radius: 10px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.modalSubmitBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secondaryBtn": `Addroducttype_secondaryBtn__KnH+h`,
	"headerActions": `Addroducttype_headerActions__EPVUe`,
	"modalBox": `Addroducttype_modalBox__2cftP`,
	"modalHeader": `Addroducttype_modalHeader__fp5NY`,
	"modalTitle": `Addroducttype_modalTitle__Fs7sS`,
	"modalClose": `Addroducttype_modalClose__CeXLW`,
	"downloadLink": `Addroducttype_downloadLink__aFYkw`,
	"modalBody": `Addroducttype_modalBody__txlIc`,
	"modalFileInput": `Addroducttype_modalFileInput__cSGZN`,
	"modalFooter": `Addroducttype_modalFooter__9J6sr`,
	"modalSubmitBtn": `Addroducttype_modalSubmitBtn__EJoMl`
};
export default ___CSS_LOADER_EXPORT___;
